import React from "react";
import "./About.css";
import SEO from "../Components/SEO";

function About() {
  return (
    <>
      <SEO
        title="Contact Us"
        description="Need help? Reach Lutology through our contact page for support and product questions."
      />

      <main className="about-page" role="main" aria-label="About Lutology">
        <section className="about-hero">
          <h1>About Lutology</h1>
          <p>Where science meets simplicity.</p>
        </section>

        <section className="about-intro">
          <h2>Our Story</h2>
          <p>
            Lutology began with a clear vision: to develop topical formulations
            that focus on comfortable and effective delivery and absorption of
            luteolin. In a market crowded with complexity and overstatement, we
            chose integrity, and science-driven clarity.
          </p>
        </section>

        <section className="about-science">
          <h2>Why Luteolin?</h2>
          <p>
            Luteolin is a plant flavonoid found in parsley, chamomile, and
            celery. It’s studied for antioxidant and soothing properties
            relevant to scalp comfort and environmental stress.
          </p>
          <p>
            Research also explores Luteolin’s role in pigmentation biology. In{" "}
            <a
              href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC11673595"
              target="_blank"
              rel="noopener noreferrer"
            >
              one animal study
            </a>
            , mice given Luteolin showed reduced hair graying and partial
            repigmentation. These are preclinical findings. our product is a
            cosmetic serum intended to support a comfortable scalp and
            resilient-looking hair.
          </p>
        </section>

        <section className="about-values">
          <h2>What We Stand For</h2>
          <ul>
            <li>
              <strong>Minimalism:</strong> Every ingredient has a purpose.
              Nothing more.
            </li>
            <li>
              <strong>Transparency:</strong> We tell you what’s inside, and why.
            </li>
            <li>
              <strong>Science Driven:</strong> Informed by research, not
              buzzwords.
            </li>
            <li>
              <strong>Kindness:</strong> Vegan. Cruelty-Free. Always.
            </li>
            <li>
              <strong>Crafted in Tel Aviv:</strong> A city of innovation and
              creativity.
            </li>
          </ul>
        </section>

        <section className="about-closing">
          <h2>A Serum With Nothing to Hide</h2>
          <p>
            We’re not trying to be everything, just the one thing that works
            cleanly and clearly. Welcome to Lutology.
          </p>
        </section>
      </main>
    </>
  );
}

export default About;
